import { UntitledIcon, type UntitledIconData } from '@faceup/icons'
import { type RouteCallback, useNavigate } from '@faceup/router'
import { Button, type ButtonProps } from '@faceup/ui-base'
import type { ReactNode } from 'react'

type MenuItemBase = {
  label: ReactNode
  icon: UntitledIconData
  variant?: 'filled' | 'light'
  dataTest?: string
  key: string
}

type MenuItemWithUrl = MenuItemBase & {
  onClick?: () => void
  url: RouteCallback
}

type MenuItemWithClick = MenuItemBase & {
  onClick: () => void
  url?: never
}

export type MenuItem = MenuItemWithUrl | MenuItemWithClick

type MenuItemsProps = {
  items: MenuItem[]
}

export const MenuItems = ({ items }: MenuItemsProps) => {
  const navigate = useNavigate()

  return (
    <div className='flex w-full flex-col gap-4 sm:flex-row'>
      {items.map(item => {
        const isFilled = item.variant === 'filled'

        const buttonProps: Omit<ButtonProps, 'children'> = {
          icon: <UntitledIcon icon={item.icon} size={19} />,
          type: 'primary',
          ghost: !isFilled,
        }

        if (item.url) {
          return (
            <div key={item.key} className='flex-1'>
              <Button
                {...buttonProps}
                onClick={() => {
                  navigate(item.url)
                  item.onClick?.()
                }}
                data-test={item.dataTest ?? undefined}
                className='w-full'
              >
                {item.label}
              </Button>
            </div>
          )
        }

        return (
          <div key={item.key} className='flex-1'>
            <Button
              onClick={item.onClick}
              data-test={item.dataTest ?? undefined}
              {...buttonProps}
              className='w-full'
            >
              {item.label}
            </Button>
          </div>
        )
      })}
    </div>
  )
}
